import { Grid } from '@material-ui/core';
import React from 'react';

import { saveRestReport, updateRestReport } from 'api/hs/definitions/health-definitions/rest-report';
import BaseDefinitionForm from 'Common/BaseDefinitionForm';
import TextField from 'Common/Form/TextField';
import { RestReportModel } from 'model/definitions/health-definitions/restReport.model';

interface Props {
  open: boolean;

  /**
   * Fires when the dialog is wanted to be closed
   * @param success `true` when the RestReport is created/updated
   */
  onClose(success: boolean): void;

  data: RestReportModel;
}

export default function PhysicalCheck({ open, onClose, data }: Props) {
  return (
    <BaseDefinitionForm<RestReportModel>
      open={open}
      onClose={onClose}
      onSave={saveRestReport}
      onUpdate={updateRestReport}
      data={data}
      resourceReloadName="restReportDefinitions"
      createTitle="İstirahat Raporu Ekleme"
      updateTitle="İstirahat Raporu Düzenleme"
      maxDialogWidth={500}>
      <Grid item lg={12} md={12}>
        <TextField required name="reasonName" label="İstirahat Raporu Adı Giriniz" />
      </Grid>
    </BaseDefinitionForm>
  );
}
